import { defineMessages } from "react-intl";

const messages = defineMessages({
  dateLabel: {
    id: "riskManagement.components.reportPicker.date.label",
    defaultMessage: "Report Date:",
  },
  sliceLabel: {
    id: "riskManagement.components.reportPicker.slice.label",
    defaultMessage: "Slice ID:",
  },
  slicePlaceholder: {
    id: "riskManagement.components.reportPicker.slice.placeholder",
    defaultMessage: "Select a Slice",
  },
  PickerLink: {
    id: "riskManagement.components.reportPicker.link",
    defaultMessage: "View Report",
  },
  PickerNone: {
    id: "riskManagement.components.reportPicker.none",
    defaultMessage: "Chose another Report",
  },
  instrument: {
    id: "riskManagement.components.reportPicker.instrument",
    defaultMessage: "View Instrument",
  },
});

export default messages;
